import { useEffect } from "react";
import { useOutletContext } from "react-router-dom";

import type { HelpGuideId } from "./helpGuides";

export type HelpOutletContext = {
  setContextualHelpGuideId: (guideId: HelpGuideId | null) => void;
  openHelpGuide: (
    guideId: HelpGuideId,
    returnFocusTarget: HTMLElement | null,
  ) => void;
};

export function useContextualHelpGuide(guideId: HelpGuideId | null): void {
  const { setContextualHelpGuideId } = useOutletContext<HelpOutletContext>();

  useEffect(() => {
    setContextualHelpGuideId(guideId);
    return () => setContextualHelpGuideId(null);
  }, [guideId, setContextualHelpGuideId]);
}

export function useHelpGuideLauncher(): HelpOutletContext["openHelpGuide"] {
  return useOutletContext<HelpOutletContext>().openHelpGuide;
}
